import { render, staticRenderFns } from "./BreadList.vue?vue&type=template&id=465bac8e&scoped=true"
import script from "./BreadList.vue?vue&type=script&lang=js"
export * from "./BreadList.vue?vue&type=script&lang=js"
import style0 from "./BreadList.vue?vue&type=style&index=0&id=465bac8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465bac8e",
  null
  
)

export default component.exports